import bridgemateAPI from '../apis/bridgemate-apigateway'
import stepFuncAPI from '../apis/stepFunc-apigateway'

import winner_list_api from '../apis/winner_list_api'
import history from '../history';
import { actionTypes } from './types';

export const fetchWinners = () => async dispatch  => {
  const winners = await winner_list_api.get('/winners');
  dispatch({type: actionTypes.FETCH_WINNERS, payload: winners.data})
};

export const editWinners = (event) => async dispatch => {
  let stepData = {}
    stepData.event_id = event.event_id;
    stepData.event_date = event.event_date;
    stepData.event_winners = event.event_winners;
    stepData.event_calendardate = event.event_day+"-"+event.event_month+"-"+event.event_year ;
    stepData.event_location = event.event_location;
    stepData.event_name = event.event_name;
    stepData.event_top_three = (event.event_top_three) ? event.event_top_three : 'No winners';
    stepData.TransactionType = "UPLOAD_EVENT_WINNERS";
    stepFuncAPI.post('/stepper', stepData);

    const response = await bridgemateAPI.get(`/event/${event.event_id}/${event.event_date}`)
    dispatch({type: actionTypes.CLEAR_EVENT, payload: response.data.Item})
    dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
    history.push('/events/list');
}

export const editResults = (event) => async dispatch => {

    let stepData = {}
    stepData.event_id = event.event_id;
    stepData.event_date = event.event_date;
    stepData.event_results = event.event_results;
    stepData.TransactionType = "EDIT_RESULTS_URI";
    stepFuncAPI.post('/stepper', stepData);

    const response = await bridgemateAPI.get(`/event/${event.event_id}/${event.event_date}`)

    dispatch({type: actionTypes.CLEAR_EVENT, payload: response.data.Item})
    dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
    history.push('/events/list');
}

export const saveResults = (event) => async dispatch => {
    let stepData = {}
    stepData.event_id = event.event_id;
    stepData.event_date = event.event_date;
    stepData.event_results = event.event_results;
    stepData.TransactionType = "EDIT_RESULTS_URI";
    await stepFuncAPI.post('/stepper', stepData);

    const response = await bridgemateAPI.get(`/event/${event.event_id}/${event.event_date}`)
    dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
}

export const editHands = (event) => async dispatch => {
    let stepData = {}
    stepData.event_id = event.event_id;
    stepData.event_date = event.event_date;
    stepData.event_hands = event.event_hands;
    stepData.TransactionType = "EDIT_HANDS_URI";
    stepFuncAPI.post('/stepper', stepData);
  }

export const saveHands = (event) => async dispatch => {
    let stepData = {}
    stepData.event_id = event.event_id;
    stepData.event_date = event.event_date;
    stepData.event_hands = event.event_hands;
    stepData.TransactionType = "EDIT_HANDS_URI";
    await stepFuncAPI.post('/stepper', stepData);

    const response = await bridgemateAPI.get(`/event/${event.event_id}/${event.event_date}`)
    dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
  }


export const editImage = (event) => async dispatch => {
   let data = JSON.stringify(event);
   const response = await bridgemateAPI.put('/event',data)
   dispatch({type: actionTypes.CLEAR_EVENT, payload: response.data.Item})
   dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
   history.push('/events/list');
}

export const editEvent = ( formValues ) => async dispatch  => {
  let data = JSON.stringify( formValues );
  const response = await bridgemateAPI.put('/event',data)
  dispatch({type: actionTypes.CLEAR_EVENT, payload: response.data.Item})
  dispatch({type: actionTypes.EDIT_EVENT, payload: response.data.Item})
  history.push('/');
};

export const createEvent = (formValues) => async (dispatch, getState)  => {
    let data = JSON.stringify( formValues );
    const response = await bridgemateAPI.post('/event', data)
    dispatch({type: actionTypes.CREATE_EVENT , payload: response.data.Item})
    history.push('/events/list');
};



export const fetchEvents = () => async dispatch  => {
    const response = await bridgemateAPI.get('/events')
    dispatch({type: actionTypes.FETCH_EVENTS, payload: response.data})
};

export const fetchResults = (results_id) => async dispatch  => {
    const response = await bridgemateAPI.get(`/results/${results_id}`)
    dispatch({type: actionTypes.FETCH_RESULTS, payload: response.data.results})
};

export const fetchEvent = (eventId, eventDate) => async dispatch  => {
    const response = await bridgemateAPI.get(`/event/${eventId}/${eventDate}`)
    dispatch({type: actionTypes.FETCH_EVENT, payload: response.data.Item})
};

export const deleteEvent = (event_id, event_date) => async dispatch => {
    let data = JSON.stringify({ event_id: event_id, event_date: event_date });
    await bridgemateAPI.delete(`/event`, {data: data});
    dispatch({type: actionTypes.DELETE_EVENT, payload: event_id})
    history.push('/events/list');
};

export const returnFromEditCreateEvent = () => async dispatch =>{
    dispatch({type: actionTypes.CLEAR_EVENT, payload:""})
    history.push('/events/list');
}

export const clearEditState = () => async dispatch =>{
  dispatch({type: actionTypes.CLEAR_EVENT, payload:""})
}

export const clearEventPageState = () => async dispatch => {
  dispatch({type: actionTypes.CLEAR_EVENT, payload:""});
}

export const returnFromEventDetails = () => async dispatch =>{
  dispatch({type: actionTypes.CLEAR_EVENT, payload:""})
  history.push('/');
}

export const returnFromResultDetail = () => async dispatch =>{
  dispatch({type: actionTypes.CLEAR_RESULTS, payload:""})
  history.push('/');
}

export const returnFromRegistered = () => async dispatch =>{
  dispatch({type: actionTypes.CLEAR_RESULTS, payload:""})
  history.push('/');
}

export const clearResultDetailsState = () => async dispatch => {
  dispatch({type: actionTypes.CLEAR_RESULTS, payload:""})
}

export const signIn = (userEmail) => {
  return {
    type: actionTypes.SIGN_IN,
    payload: userEmail
  };
};

export const signOut = () => { return { type: actionTypes.SIGN_OUT }; };

export { auth, logout, authCheckState } from './auth'

export { reg } from './reg'